let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a0ALI")).then(() => parcelRequire('hfn9j'));